import React, { PureComponent } from 'react'
import { string } from 'prop-types'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import AuthActions from 'store/redux/auth'
import { translate } from 'react-i18next'
import './AdminNavBar.css'

@connect(
    null,
    {
        navigate: push,
        signout: AuthActions.signout
    }
)
@translate()
export class AdminNavBar extends PureComponent {
    static propTypes = {
        backRoute: string
    }


    render() {
        const { backRoute, navigate, signout, t } = this.props

        return (
            <div className="AdminNavBar flex row-stretch-center px-5 py-2">
                {backRoute ? <a className="AdminNavBar-Back" onClick={() => navigate(backRoute)}>&larr; {t('superadmin.back')}</a> : <div />}
                <a className="AdminNavBar-Signout" onClick={() => signout(true)}>{t('superadmin.signout')}</a>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/AdminNavBar/AdminNavBar.js